/**
 * 주문 검증 및 유틸리티 함수
 * 기존 order.ts의 private 메서드들
 */

import { supabase } from '@/lib/supabase';

/**
 * 재고 가용성 검증
 */
export async function validateStockAvailability(
  productId: string, 
  quantity: number
): Promise<{ available: boolean; currentStock: number }> {
  try {
    const { data } = await supabase
      .from('product_stock')
      .select('current_stock')
      .eq('product_id', productId)
      .eq('date', new Date().toISOString().split('T')[0])
      .single();

    if (!data) {
      return { available: false, currentStock: 0 };
    }

    return {
      available: data.current_stock >= quantity,
      currentStock: data.current_stock
    };
  } catch (error) {
    return { available: false, currentStock: 0 };
  }
}

/**
 * 주문 타입별 수수료율 계산
 */
export function getCommissionRate(orderType: string): number {
  switch (orderType) {
    case 'DEADLINE_DISCOUNT':
      return 0.15; // 15%
    case 'RESERVATION_DISCOUNT':
    case 'REGULAR_ORDER':
      return 0.06; // 6%
    default:
      return 0.06;
  }
}

/**
 * 마감할인 주문 가능 시간 확인
 */
export function isValidDeadlineDiscountTime(): boolean {
  // 기존: 현재 시각이 18시 이후인지 여부만 판단 (UTC/KST 시차 + 매장 설정 무시) → 정상 시간에도 차단되는 문제 발생
  // 개선: 주문 가능 여부는 매장 설정(레스토랑 마감할인 시간/오퍼)에서 판단하므로 여기서는 항상 true로 통과시키고
  // 실제 검증은 주문 생성 흐름/오퍼 시간에서 수행한다.
  return true;
}
